// extracted by mini-css-extract-plugin
module.exports = {"cultivo-tr":"cards_cultivo-tr__1FtNV","trabajador-actividad-list":"cards_trabajador-actividad-list__3uesm"};